import { Icon } from 'lego-on-react';
// eslint-disable-next-line @typescript-eslint/no-use-before-define
import * as React from 'react';

import block from 'propmods';

import './OrderPick.scss';

const b = block('OrderPick');

type OrderPickProps = {
    order: number;
    disablePrev: boolean;
    disableNext: boolean;
    onPrev: (_idx: number) => void;
    onNext: (_idx: number) => void;
};
export const OrderPick = ({ onNext, onPrev, order, disableNext, disablePrev }: OrderPickProps) => {
    const onPrevCb = React.useCallback(() => {
        onPrev(order);
    }, [onPrev, order]);
    const onNextCb = React.useCallback(() => {
        onNext(order);
    }, [onNext, order]);
    return (
        <div {...b()}>
            <span {...b('prev', { disabled: disablePrev })} onClick={onPrevCb}>
                <Icon type="arrow" direction="top" />
            </span>
            <span {...b('order')}>{order + 1}</span>
            <span {...b('next', { disabled: disableNext })} onClick={onNextCb}>
                <Icon type="arrow" direction="bottom" />
            </span>
        </div>
    );
};
